export enum BatchStatus {
    New,
    InProgress,
    Submitted
}